var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.5,
    height: 12,
    viewBox: "0 0 11.5 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1d0e3d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.5,11.36a.633.633,0,0,1-.639.64H.639a.616.616,0,0,1-.454-.186A.619.619,0,0,1,0,11.36V4.623a.607.607,0,0,1,.243-.5L5.354.141a.627.627,0,0,1,.792,0l5.111,3.983a.62.62,0,0,1,.243.512Zm-1.278-.64V4.943L5.75,1.46,1.278,4.943v5.776ZM2.556,8.158H8.944V9.439H2.556Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.e569f33fab710804f083c6558cdf58cd.svg";
export { ForwardRef as ReactComponent };